import React from "react";
import Layout from './shared/Layout';
import RoutesComponent from './routes/Routes';
import { CourseProvider} from "../context/CourseContext";

function App() {
  return (
    <CourseProvider>
    <Layout >
      <RoutesComponent />
    </Layout>
    </CourseProvider>
  );
}

export default App;